<template>
  <a-table
    :columns="columns"
    :rowSelection="commonState.rowSelection"
    rowKey="id"
    :pagination="tableRelevant.tablePagination"
    :loading="tableRelevant.tableLoading"
    :locale="tableRelevant.locale"
    :scroll="{ y: 400 }"
    :dataSource="tableRelevant.tableDataSource"
  >
    <div slot="abilityTypeName" slot-scope="text">
      <div class="self_td" v-for="item in text.contentAbility" :key="item.id">
        {{ item.abilityTypeName }}- {{ item.firstAbilityName }}-
        {{ item.secondAbilityName }}
      </div>
    </div>
    <div slot="classifyTag" slot-scope="text">
      <span style="color: green" v-if="text.classifyTag == 1">商用</span>
      <span style="color: #f90" v-else-if="text.classifyTag == 4">科研</span>
      <span v-else>--</span>
    </div>
    <div slot="ages" slot-scope="text, record">{{ record.minAge }}-{{ record.maxAge }}</div>
    <div slot="normNum" slot-scope="text, record">
      <div class="self_td" v-for="item in record.contentAbility" :key="item.id">
        {{ item.normCount }}
      </div>
    </div>
    <div slot="estimatedTime" slot-scope="text, record">
      {{ EstimatedTime(record.estimatedTime) }}
    </div>
  </a-table>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { EstimatedTime } from '@/utils/EstimatedTime'

const columns = [
  {
    title: '名称',
    dataIndex: 'name',
  },
  {
    title: '版本',
    dataIndex: 'versionName',
  },
  {
    title: '质量标准',
    scopedSlots: { customRender: 'classifyTag' },
  },
  {
    title: '能力维度',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  {
    title: '适用年龄',
    scopedSlots: { customRender: 'ages' },
  },
  {
    title: '预计用时',
    scopedSlots: { customRender: 'estimatedTime' },
  },
]

export default {
  name: 'SelectGameContentGameList',
  props: {},
  inject: ['getCommonState'],

  data() {
    return {
      columns: Object.freeze(columns),
      tableRelevant: tableRelevant.call(this),
    }
  },
  computed: {
    commonState() {
      return this.getCommonState()
    },
  },
  methods: {
    EstimatedTime,
    getPageList(reset) {
      this.tableRelevant.tableLoading = true
      if (reset) {
        this.tableRelevant.tablePagination.current = 1
      }

      const params = {
        pageIndex: this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        contentType: this.commonState.activeTab,
        name: this.commonState.searchForm.name,
        status: true,
      }

      this.$http
        .contentPagelist(params)
        .then((res) => {
          this.tableRelevant.tableDataSource = res.data.data.items
          this.tableRelevant.tablePagination.total = res.data.data.totalCount
          this.tableRelevant.tableLoading = false
        })
        .catch((err) => {
          this.tableRelevant.tableLoading = false
        })
    },
  },
}
</script>
<style scoped>
/* 隐藏表头的全选 checkbox */
::v-deep .ant-table-thead .ant-checkbox-wrapper,
.ant-table-thead .ant-checkbox {
  display: none !important;
}
</style>
